var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.5001H16.67L11.79 18.3801C11.4 18.7701 11.4 19.4101 11.79 19.8001C12.18 20.1901 12.81 20.1901 13.2 19.8001L19.79 13.2101C20.18 12.8201 20.18 12.1901 19.79 11.8001L13.21 5.20009C12.82 4.81009 12.19 4.81009 11.8 5.20009C11.41 5.59009 11.41 6.22009 11.8 6.61009L16.67 11.5001H5.5C4.95 11.5001 4.5 11.9501 4.5 12.5001C4.5 13.0501 4.95 13.5001 5.5 13.5001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.1c67623ea389d64ce6cd52715dc72bd7.svg";
export { ForwardRef as ReactComponent };